// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HlingBimWFdZzI {
  grid-area: statetaxid;
}
label.dwdj5NWBfhbW4l {
  display: inline-flex;
}
.Cu5eh12AQuHHqx {
  display: block;
}
`, ""]);
// Exports
export var isVatRegistered = `HlingBimWFdZzI`;
export var vatCheckbox = `dwdj5NWBfhbW4l`;
export var vatCheckboxContainer = `Cu5eh12AQuHHqx`;
export default ___CSS_LOADER_EXPORT___;
